<div class="jobs-panel">
  <div class="panel-header">
    <h2 class="panel-title">Job Status</h2>
    <button
      type="button"
      class="close-button"
      (click)="close()"
      aria-label="Close panel"
    >
      <lib-cdw-icon icon="close"></lib-cdw-icon>
    </button>
  </div>

  <mat-tab-group
    [(selectedIndex)]="activeTabIndex"
    (selectedIndexChange)="onTabChange($event)"
    class="jobs-tabs"
  >
    <!-- My Jobs Tab -->
    <mat-tab label="My Jobs">
      <div class="panel-content">
        <div *ngIf="myJobsLoading" class="loading-state">
          <mat-spinner [diameter]="48"></mat-spinner>
          <p class="loading-text">Loading jobs...</p>
        </div>

        <div *ngIf="!myJobsLoading && myJobs.length === 0" class="empty-state">
          <lib-cdw-icon icon="done_all" class="empty-icon"></lib-cdw-icon>
          <p class="empty-text">No recent jobs</p>
        </div>

        <div class="jobs-list" *ngIf="!myJobsLoading && myJobs.length > 0">
          <app-job-card *ngFor="let job of myJobs" [job]="job"></app-job-card>
        </div>
      </div>
    </mat-tab>

    <!-- All Jobs Tab -->
    <mat-tab label="All Jobs">
      <div class="panel-content">
        <div *ngIf="allJobsLoading" class="loading-state">
          <mat-spinner [diameter]="48"></mat-spinner>
          <p class="loading-text">Loading jobs...</p>
        </div>

        <div *ngIf="!allJobsLoading && allJobs.length === 0" class="empty-state">
          <lib-cdw-icon icon="done_all" class="empty-icon"></lib-cdw-icon>
          <p class="empty-text">No recent jobs</p>
        </div>

        <div class="jobs-list" *ngIf="!allJobsLoading && allJobs.length > 0">
          <app-job-card
            *ngFor="let job of allJobs"
            [job]="job"
            [showCreator]="true"
          ></app-job-card>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
